export default "__VITE_ASSET__DKLAfTVg__"